<template>
    <div v-show="userPermissionsFilter.mobiletransactionsreports">
        <h2 class="text-white">Mobile Money Transactions</h2>
        <div id="plug">
            <div v-if="showTimer" class="v" style="color:red">We are moving this module to <a :href=newbackofficeurl
                    target="_blank">New
                    Backoffice</a>. This module will be permanently disabled in {{ timerOutput }}</div>
            <div v-else class="v"></div>
        </div>
        <div class="table-responsive">
            <table class="table" id="datatable" style="color:white;">
                <thead>
                    <tr>
                        <th>Transaction Reference</th>
                        <th>Mobile Money Status</th>
                        <th>Mobile Money Reference</th>
                        <th>Transaction Date</th>
                        <th>Phone Number</th>
                        <th>Amount</th>
                        <th>Created On</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in usersdata" :key="item.id">
                        <td>{{ item.transactionReference }}</td>
                        <td>{{ item.mpesaStatus }}</td>
                        <td>{{ item.mpesaReference }}</td>
                        <td>{{ item.transactionDate }}</td>
                        <td>{{ item.phoneNumber }}</td>
                        <td>{{ item.amount }}</td>
                        <td>{{ item.createdOn }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { newbackofficeurl } from "../../package.json";
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"

import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import $ from 'jquery';
import PermissionsMixins from "@/mixins/PermissionsMixins";
import router from '@/router/';

export default {
    name: 'MpesaTransactions',
    data: function () {
        return {
            usersdata: '',
            userdata: '',
            //IdProfile = "data:image/png;base64," + response.data;

            newbackofficeurl: "",
            countDownToTime: new Date('Nov 12, 2024 00:00:00').getTime(),
            timerOutput: '',
            showTimer: true
        }
    },
    computed: {
    },
    methods: {
        refreshUsers() {
            this.pageLoading = true;
            this.getAllMpesaTransactions()
                .then((result) => {
                    this.usersdata = result.items;
                    this.$nextTick(function () {
                        this.initDt()
                    });

                    this.pageLoading = false;
                })
        },
        initDt() {
            $('#datatable').DataTable({
                retrieve: true,
                dom: 'Blfrtip',
                "aaSorting": [],
                // buttons: [
                //     'print', 'csv', 'excel', 'pdf'
                // ],
                initComplete: function () {
                    var api = this.api();
                },
            });
        }
    },
    mounted() {
        //API Call
        this.getLoggedInCompany()
            .then((loggedInCompany) => {
            });
    },
    created() {
        this.startTimer();
        let self = this;
        this.newbackofficeurl = self.$newbackofficeurl;

        this.refreshUsers();
    },
    mixins: [PermissionsMixins],
}

</script>

<style>
table.dataTable tbody tr {
    background-color: #191d24;
}

table.dataTable {
    margin-left: 0px;
    text-align: left;
}

.avatar-box {
    background: #3773e2;
    margin-bottom: 50px;
    position: relative;
}

.avatar-box img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    position: relative;
    bottom: -50px;
    display: block;
    margin: 0 auto;
    background: white;
    border: 2px solid #3773e2;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.dataTables_filter label,
.dataTables_wrapper .dataTables_filter input {
    color: white !important;
}

.dataTables_wrapper .dataTables_filter input ::placeholder,
.dataTables_wrapper .dataTables_filter input ::-ms-input-placeholder {
    color: white !important;
}

.dataTables_wrapper .dataTables_paginate a.paginate_button {
    color: white !important;
}
</style>